export  default {
    WIZARD_LOADED_STEPS: 'WIZARD_LOADED_STEPS',
    DELETE_SELECTED_WIZARD_STEPSID: 'DELETE_SELECTED_WIZARD_STEPSID'
   } 